<template>
    <div class="RPFilter">
        <RPDropdownButton
            ref="button"
            :dropdown-position="dropdownPosition"
            :type="type"
            :disabled="disabled"
            :default-label="defaultLabel"
            :default-icon="defaultIcon"
            :default-icon-size="defaultIconSize"
            :default-icon-color="defaultIconColor"
            :hide-arrow="hideArrow"
        >
            <template v-slot:default="{open, toggleDropdown}">
                <slot
                    :open="open"
                    :toggleDropdown="toggleDropdown"
                ></slot>
            </template>
            <template v-slot:dropdown="{isModal, close}">
                <slot
                    name="dropdown"
                    :isModal="isModal"
                    :close="close"
                ></slot>
            </template>
        </RPDropdownButton>
    </div>
</template>
<script>
import RPDropdownButton from 'components/Basic/Buttons/DropdownButton/RPDropdownButton.vue';
import colors from 'style/_colors.scss';
export default {
    name: 'RPFilter',
    components: {
        RPDropdownButton,
    },
    props: {
        type: {
            type: String,
            default: 'primary',
            validator: val => ['primary', 'secondary', 'tertiary'].indexOf(val) !== -1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        defaultLabel: {
            type: String,
            default: 'Select',
        },
        defaultIcon: {
            type: [Object, Array],
            default: () => ({}),
        },
        defaultIconSize: {
            type: Number,
            default: 16,
        },
        defaultIconColor: {
            type: String,
            default: colors.grey600,
        },
        hideArrow: {
            type: Boolean,
            default: false,
        },
        dropdownPosition: {
            type: String,
            default: 'right',
            validator: val => ['left', 'right', 'center'].indexOf(val) !== -1
        },
    },
};
</script>
<style lang="scss">
.RPFilter {
}
</style>
